module.exports = __webpack_public_path__ + "static/img/1059_small.445b2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1059_small.png
// module id = icCQ
// module chunks = 1